import { render, staticRenderFns } from "./AppTotal.vue?vue&type=template&id=345c3614&"
import script from "./AppTotal.vue?vue&type=script&lang=js&"
export * from "./AppTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports